import { careerIdToLayoutData } from '@cp/entities/career';
import { useModalPromise } from '@cp/shared/modal';
import { AsyncResult, Result } from '@cp/shared/result';
import { useCallback } from 'react';
import { CareerId } from '@common/const/catalog/career';
import { CLIENT_TYPE_MODAL } from 'src/entities/client';
import { CAREER_MODAL } from '../lib';
import { ClientSelection } from './clientSelection.interface';
import { useClientSelectionService } from './useClientSelectionService';
import { SelectionType } from './clientSelectionService';

export type QuizQuestions = Array<keyof ClientSelection>;
export type QuizFeature = (q: QuizQuestions) => AsyncResult<ClientSelection, Error>;

export const useQuizFeature = (): QuizFeature => {
  const service = useClientSelectionService();
  const askClientType = useModalPromise(CLIENT_TYPE_MODAL);
  const askCareerId = useModalPromise(CAREER_MODAL);

  return useCallback(
    async (questions) => {
      console.debug('Start ClientSelection/quiz feature');
      for (const question of questions) {
        switch (question) {
          case 'clientType':
            const CareerIcon = careerIdToLayoutData[service.getSelections().careerId || CareerId.Nanny].iconComponent;
            const clientType = await askClientType({ CareerIcon });
            service.register({ clientType }, SelectionType.ClientAction);
            break;
          case 'careerId':
            const careerId = await askCareerId({ title: 'Ищу работу' });
            service.register({ careerId }, SelectionType.ClientAction);
            break;
          default:
            return Result.Err(new Error(`Unsupported quiz question: ${question}`));
        }
      }
      return Result.Ok(service.getSelections());
    },
    [service, askClientType, askCareerId],
  );
};
